export default __webpack_public_path__ + "static/media/SWT1700.34I-39137_-23036_0.3ef8bb3e.jpg";